import * as React from 'react';
import { Grid, StyledComponentProps } from '@material-ui/core';
import { tag } from '../../../../model/tag';
import TextField from '../../../../ui-components/TextField/TextField';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';
import { SearchBoxApi } from '../../../../ui-components/SearchBoxApi/SearchBoxApi';
import { invokeApi } from '../../../../common/networking/invoker';
import Button from '../../../../ui-components/Button/Button';

interface IProps extends StyledComponentProps {
    handleChangeFullnameOrEmail: (val: string) => void;
    fullnameOrEmail?: string;
    search: (fullnameOrEmail?: string, tag?: tag) => void;
    handleChangeTagCode: (val: tag) => void;
    selctedTag?: tag;
    new: () => void;
    loading: boolean;
    classes: any;
}


const searchTagsSearchBox = (search: string, take?: number): Promise<Array<tag>> => {
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts/tags?codeOrDescription=${search}&take=${take}`
                : `api/Contacts/tags?codeOrDescription=${search}`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}


const templateSearchBoxTag = (tag?: tag) => {
    return tag ? {
        label: (tag.code ? tag.code + " - " : "") + tag.description,
        value: tag
    } : undefined;
}

export const Filters = (props: IProps) => {
    const classes = props.classes;
    return (
        <Grid container xs={12} className={classes.root} spacing={2}>
            <Grid item xs={12} sm={4} >
                <TextField label='Cognome o Mail'
                    onKeyDown={(e) => {
                        //Enter KeyCode = 13
                        if (e.keyCode === 13) {
                            props.search(props.fullnameOrEmail, props.selctedTag)
                        }
                    }}
                    disabled={props.loading}
                    onChange={props.handleChangeFullnameOrEmail}
                    value={props.fullnameOrEmail} />
            </Grid>
            <Grid item xs={12} sm={4}>
                <SearchBoxApi<tag>
                    selectedItem={undefined}
                    openOnFocus
                    doFilter
                    disabled={props.loading}
                    listSize={10}
                    onValueSubmit={(item) => {
                        props.handleChangeTagCode(item)
                        props.search(props.fullnameOrEmail, item)

                    }}
                    getItems={searchTagsSearchBox}
                    label={"Tag"}
                    placeholder={"Digitare descrizione o codice"}
                    templateItem={templateSearchBoxTag}
                    onSelectedChange={(item) => { props.handleChangeTagCode(item) }} />
            </Grid>
            <Grid item xs={3} sm={2} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <Button className={classes.searchButton} onClick={() => props.search(props.fullnameOrEmail, props.selctedTag)}>Cerca</Button>
                </div>
            </Grid>
            <Grid item xs={3} sm={2} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <NewItemButton disabled={props.loading} onClick={() => props.new()} text="Nuovo" />
                </div>
            </Grid>
        </Grid>
    );
}
